import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { colors } from '../../DesignSystem/colors';
import { BreakpointsPx } from '../../DesignSystem/design-system';
import { elevation } from '../../DesignSystem/elevation';
import { Icons } from '../../Icons/Icons';
import ImpIcon from '../../Molecules/ImpIcon/ImpIcon';
import { ImpLoyaltyTracker } from './ImpLoyaltyTracker';
export function ImpLoyaltyTrackerCarousel({ items, parentBackgroundColorHex, }) {
    const ContainerRef = useRef(null);
    const [scrollPosition, setScrollPosition] = useState(0);
    const [clientWidth, setClientWidth] = useState(0);
    const [contentWidth, setContentWidth] = useState(0);
    const goLeftVisible = scrollPosition > 0;
    const goRightVisible = scrollPosition + clientWidth < contentWidth;
    const isMobile = clientWidth < BreakpointsPx.Mobile;
    useEffect(() => {
        const container = ContainerRef.current;
        if (!container) {
            return;
        }
        setClientWidth(container.clientWidth);
        setContentWidth(container.scrollWidth);
        const handleScroll = () => {
            setScrollPosition(container.scrollLeft);
        };
        const handleResize = () => {
            setClientWidth(container.clientWidth);
            setContentWidth(container.scrollWidth);
        };
        container.addEventListener('scroll', handleScroll);
        window.addEventListener('resize', handleResize);
        return () => {
            container.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', handleResize);
        };
    });
    const SCROLL_STEP = 135 * 1.2;
    const scrollLeft = () => {
        const container = ContainerRef.current;
        if (container) {
            container.scrollBy({ left: -SCROLL_STEP, behavior: 'smooth' });
        }
    };
    const scrollRight = () => {
        const container = ContainerRef.current;
        if (container) {
            container.scrollBy({ left: SCROLL_STEP, behavior: 'smooth' });
        }
    };
    return (React.createElement(Wrapper, null,
        React.createElement(ScrollFade, { pos: "left", visible: goLeftVisible, color: parentBackgroundColorHex || colors.surface.surfaceLow }),
        React.createElement(Container, { ref: ContainerRef }, items.map((item, idx) => (React.createElement(ImpLoyaltyTracker, { ...item, key: idx })))),
        !isMobile && goLeftVisible && (React.createElement(ScrollButton, { onClick: scrollLeft },
            React.createElement(ImpIcon, { iconSrc: Icons.chevronLeft }))),
        !isMobile && goRightVisible && (React.createElement(ScrollButton, { style: { right: '0' }, onClick: scrollRight },
            React.createElement(ImpIcon, { iconSrc: Icons.chevronRight }))),
        React.createElement(ScrollFade, { pos: "right", visible: goRightVisible, color: parentBackgroundColorHex || colors.surface.surfaceLow })));
}
const Wrapper = styled.div `
  position: relative;
`;
const ScrollFade = styled.div `
  position: absolute;
  top: 0;
  bottom: 0;
  width: 32px;
  background: linear-gradient(
    to ${({ pos }) => pos},
    ${({ color }) => color}00,
    ${({ color }) => color}FF
  );
  pointer-events: none;
  z-index: 2;
  ${({ pos }) => pos}: -1px;

  transition: opacity 0.3s;
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  border-radius: ${({ visible }) => (visible ? '0' : '0 12px 12px 0')};
`;
const Container = styled.div `
  position: relative;
  width: 100%;
  max-width: 100%;
  overflow: auto;
  display: flex;
  -webkit-box-align: stretch;
  align-items: stretch;
  scroll-snap-type: x mandatory;
  scrollbar-width: none;
  gap: 8px;
`;
const ScrollButton = styled.button `
  position: absolute;
  top: calc(50% - 20px);
  bottom: 0;

  width: 32px;
  height: 32px;
  color: white;
  cursor: pointer;
  border-radius: 50%;

  z-index: 200;

  border: 1px solid ${colors.border.borderVariant};

  padding: 0;

  display: flex;
  justify-content: center;
  align-items: center;

  box-shadow: ${elevation.primary3};

  background-color: ${colors.surface.surfaceHigh};
`;
//# sourceMappingURL=ImpLoyaltyTrackerCarousel.js.map